module.exports = __webpack_public_path__ + "img/cns_email_pc3.a7da5716.png";